import { render, staticRenderFns } from "./Polls.vue?vue&type=template&id=1e0f9cd0"
import script from "./Polls.vue?vue&type=script&lang=ts"
export * from "./Polls.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports